import React from "react";
import ReactDOM from "react-dom";
import VideoModal from "./VideoModal";

const languageModalContainer = document.getElementById("video-modal-container");

if (languageModalContainer) {
  ReactDOM.render(<VideoModal />, languageModalContainer);
}
